import { UIPageEnum } from '@/enums/ui.page.enum'
import { ChatbotLayout } from '@/layouts'
import type { RouteRecordRaw } from 'vue-router'
import { v1LayoutRoutes } from './routes.v1'
import { authRoutes } from './routes.auth'
import { defaultChatbotId } from './route.constants'

const appIndexPath = `${UIPageEnum.CHATBOT_ROOT}/${defaultChatbotId}`

const rootLayoutRoute = {
  path: UIPageEnum.ROOT_LAYOUT,
  name: UIPageEnum.ROOT_LAYOUT_NAME,
  redirect: appIndexPath,
  childen: [...v1LayoutRoutes],
}

const chatLayoutRoute: RouteRecordRaw = {
  path: UIPageEnum.CHATBOT_ROOT,
  name: UIPageEnum.CHATBOT_ROOT_NAME,
  component: ChatbotLayout,
  redirect: `${UIPageEnum.CHATBOT_ROOT}/${defaultChatbotId}`,
  children: [
    {
      path: '/chat/:chatid',
      name: UIPageEnum.CHATBOT_ASSISTANT_NAME,
      component: () => import('@/pages/chatbot/ChatbotIndex.vue'),
      meta: {
        title: '智能助手',
        // goback:'/'
      },
    },
  ],
}

export const routes: RouteRecordRaw[] = [
  rootLayoutRoute,
  authRoutes,
  chatLayoutRoute,
  { path: '/:pathMatch(.*)*', redirect: '/' },
]
